/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_More_About_JxdInputs */

const en_marketing_more_about_jxd = /** @type {(inputs: Marketing_More_About_JxdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More about JXD`)
};

const es_marketing_more_about_jxd = /** @type {(inputs: Marketing_More_About_JxdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más sobre JXD`)
};

const fr_marketing_more_about_jxd = /** @type {(inputs: Marketing_More_About_JxdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur JXD`)
};

/**
* | output |
* | --- |
* | "More about JXD" |
*
* @param {Marketing_More_About_JxdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_more_about_jxd = /** @type {((inputs?: Marketing_More_About_JxdInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_More_About_JxdInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_more_about_jxd(inputs)
	if (locale === "es") return es_marketing_more_about_jxd(inputs)
	return fr_marketing_more_about_jxd(inputs)
});